module.exports = __webpack_public_path__ + "static/slack-daf8b1e158b776767a9637f0e71ef21d.png";